import IdtfEOSReview from './IdtfEOSReview';

export default IdtfEOSReview;



// WEBPACK FOOTER //
// ./src/views/pages/IdtfEOSReview/index.js